import {
  InputOverrideType,
  QuestionManagementContextProps,
  MetricOverrideType,
} from '@features/question-configuration';
import React, { useState } from 'react';

const initialState: QuestionManagementContextProps = {
  inputOverrideType: undefined,
  setInputOverrideType: () => {},
  metricOverrideCode: undefined,
  setMetricOverrideCode: () => {},
};

export const QuestionManagementContext = React.createContext(initialState);

export default function QuestionManagementContainer({ children }: { children: React.ReactNode }) {
  const [inputOverrideType, setInputOverrideType] = useState<InputOverrideType | undefined>(
    initialState.inputOverrideType,
  );
  const [metricOverrideCode, setMetricOverrideCode] = useState<keyof MetricOverrideType | undefined>(
    initialState.metricOverrideCode,
  );

  const contextValue: QuestionManagementContextProps = {
    inputOverrideType,
    setInputOverrideType,
    metricOverrideCode,
    setMetricOverrideCode,
  };

  return <QuestionManagementContext.Provider value={contextValue}>{children}</QuestionManagementContext.Provider>;
}
